import { useLocation } from "react-router-dom";

import Verification from ".";

/**
 * Forces a fresh Verification per OTP leg.
 *
 * The flow visits /auth/verify twice — once for channel 1, again for the
 * auto-fired channel 2 — and React Router would keep the same component
 * mounted across that navigation, leaving it holding leg 1's sessionId and
 * stage. This is the web equivalent of the React Navigation bug the app hit,
 * and the documented fix is a key that changes per leg.
 *
 * `location.key` is unique per history entry, so it changes even on a
 * `replace`. `legKey` is preferred when the flow supplied one.
 */
const VerificationRoute = () => {
  const location = useLocation();

  return <Verification key={location.state?.legKey || location.key} />;
};

export default VerificationRoute;
